import React from 'react';
import { HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-cream py-20 px-6 md:px-8" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-207">
      <div className="max-w-3xl mx-auto" data-id="element-208">
        <div className="flex items-center gap-3 mb-6 text-rose-DEFAULT" data-id="element-209">
          <HeartCrack className="w-8 h-8" data-id="element-210" />
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text" data-id="element-211">
            Esto es para ti si…
          </h2>
        </div>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-text/80" data-id="element-212">
          <p data-id="element-213">
            Eres mamá primeriza, millennial, hispanohablante en Estados Unidos…
            y el primer mes te cayó como un camión.
          </p>

          <p className="font-medium text-text" data-id="element-214">
            No porque no ames a tu bebé. Sino porque:
          </p>

          <ul className="space-y-4 pl-2" data-id="element-215">
            {['estás funcionando a pedazos', 'duermes en bloques ridículos', 'tu cuerpo duele o se siente raro', "tu mente salta entre 'todo bien' y 'no puedo'", "y encima te dices a ti misma: 'debería poder'."].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-216">
                <span className="mt-2 w-2 h-2 rounded-full bg-rose-DEFAULT flex-shrink-0" data-id="element-217" />
                <span data-id="element-218">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}